import { render, staticRenderFns } from "./EtapaEscolarEscola.vue?vue&type=template&id=64824659&"
import script from "./EtapaEscolarEscola.vue?vue&type=script&lang=js&"
export * from "./EtapaEscolarEscola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports